import { useState, useEffect } from 'react'
import { getAssetDashboard } from './assetDashboardService'

export const useAssetDashboard = () => {
  const [teams, setTeams] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    getAssetDashboard()
      .then(data => {
        if (cancelled) return
        setTeams(data ?? [])
        setLoading(false)
      })
      .catch(() => {
        if (cancelled) return
        setError('Failed to load asset dashboard')
        setLoading(false)
      })

    return () => { cancelled = true }
  }, [])

  return { teams, loading, error }
}
